import { Routes } from '@/routes';

export default {
	'document-template.index': () => import('@/modules/document-templates/index'),
	'document-template.new': () => import('@/modules/document-templates/form'),
	'document-template.edit': () => import('@/modules/document-templates/form'),
} as Routes;
